import React, {useEffect, useState} from 'react';

import {useNavigate, useParams} from 'react-router-dom';
import ENDPOINTS from '../../constants/endpoints';
import {ROUTES, formatPath} from '../../constants/PathRoutes';
import api from '../../services/api';
import useDefaultRequest from '../../hooks/useDefaultRequest';
import Form from "../../components/data_entry/form/Form";
import InputFormField from "../../components/data_entry/form/InputFormField";
import TextAreaFormField
    from "../../components/data_entry/form/TextAreaFormField";
import SwitchFormField from "../../components/data_entry/form/SwitchFormField";
import {Col, message, Row, Typography} from "antd";
import Button from "../../components/data_entry/Button";
import Loading from "../../components/admin/Loading";

const FORM_NAMES = {
    QUESTION: 'question',
    ANSWER: 'answer',
    IS_ACTIVE: 'is_active',
};

export default function AdminFAQForm() {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const {id} = useParams();
    const isEditing = !!id;

    const {data, isLoading: fetching} = useDefaultRequest({
        url: formatPath(ENDPOINTS.FAQ_DETAIL, {id}),
        makeRequest: isEditing,
        redirectRoute: ROUTES.ADMIN_FAQ_LIST
    });

    useEffect(() => {
        if (data && isEditing) {
            form.setFieldsValue(data);
        }
    }, [data, isEditing, form]);

    const onFinish = async (values) => {
        setLoading(true);
        try {
            if (isEditing) {
                await api.put(formatPath(ENDPOINTS.FAQ_DETAIL, {id}), values);
                message.success('FAQ atualizada com sucesso');
            } else {
                await api.post(ENDPOINTS.FAQ_LIST, values);
                message.success('FAQ criada com sucesso');
            }
            navigate(ROUTES.ADMIN_FAQ_LIST);
        } catch (error) {
            message.error(error.response?.data?.detail || 'Erro ao salvar FAQ');
        } finally {
            setLoading(false);
        }
    };

    if (fetching) {
        return <Loading />;
    }

    return (
        <Row>
            <Col xs={24}>
                <Typography.Title
                    style={{marginTop: 0}}
                    level={2}>{isEditing ? 'Editar FAQ' : 'Nova FAQ'}</Typography.Title>
            </Col>
            <Col xs={24}>
                <Form
                    form={form}
                    onFinish={onFinish}
                    initialValues={{[FORM_NAMES.IS_ACTIVE]: true}}
                >
                    <Row>
                        <Col xs={24}>
                            <InputFormField placeholder="Digite a pergunta"
                                            form={{
                                                label: "Pergunta",
                                                name: FORM_NAMES.QUESTION,
                                                rules: [{
                                                    required: true,
                                                    message: 'Informe a pergunta'
                                                }]
                                            }}/>
                        </Col>
                        <Col xs={24}>
                            <TextAreaFormField rows={4}
                                               placeholder="Digite a resposta"
                                               form={{
                                                   label: "Resposta",
                                                   name: FORM_NAMES.ANSWER,
                                                   rules: [{
                                                       required: true,
                                                       message: 'Informe a resposta'
                                                   }]
                                               }}/>
                        </Col>
                        <Col xs={24}>
                            <SwitchFormField
                                form={{
                                    label: "Ativo",
                                    name: FORM_NAMES.IS_ACTIVE,
                                }}
                            />
                        </Col>
                        <Col xs={24} style={{textAlign: 'right'}}>
                            <Button onClick={form.submit}
                                    loading={loading}>
                                Salvar
                            </Button>
                            <Button
                                type={'default'}
                                style={{marginLeft: 8}}
                                onClick={() => navigate(ROUTES.ADMIN_FAQ_LIST)}
                            >
                                Cancelar
                            </Button>
                        </Col>
                    </Row>


                </Form>
            </Col>
        </Row>
    );
}